import { Action, handleActions } from 'redux-actions'
import { GroupMemberDto } from '../../../services/api.types'
import { getGroupMembers, getGroupMembersFail, getGroupMembersSuccess } from './MyGroupsActions'

export interface MyGroupsState {
  members: GroupMemberDto[]
  loading: boolean
}

const initialState: MyGroupsState = {
  members: [],
  loading: false,
}

export const myGroups = handleActions<MyGroupsState, any>(
  {
    [String(getGroupMembers)]: (state) => ({
      ...state,
      loading: true,
    }),
    [String(getGroupMembersSuccess)]: (state, action: Action<{ members: GroupMemberDto[] }>) => ({
      ...state,
      members: action.payload.members || [],
      loading: false,
    }),
    [String(getGroupMembersFail)]: (state) => ({
      ...state,
      members: [],
      loading: false,
    }),
  },
  initialState,
)
